
type Customer = {
  selectedCustomer: any;
};
export default function CustomerInfo({
  selectedCustomer,
}: Customer) {

  return (
     <div className="flex flex-col h-[calc(80.5vh-200px)] 2xl:h-[calc(84vh-200px)] 4xl:h-[calc(90vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">
     <div className="sm:grid gap-3 mb-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* <thead>
            <tr className="bg-greenBg text-white">
              <th className="p-2 text-left w-1/3">Info</th>
              <th className="p-2 text-left w-1/3">Contact</th>
              <th className="p-2 text-left w-1/3">Report</th>
            </tr>
          </thead> */}

          <div className='border-r-[1px] pr-3 border-r-[#EEEEEE]'>
            <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                    <img src="/assets/img/list-info.png" alt="" className='personIcon' />
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Info</h2>
                            </div>
                 <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                DOT Number</label>
                 <p className="text-[13.5px] font-normal text-gray-900">{selectedCustomer?.dot ?? "N/A"}</p>
                </div>

                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">MC Number</label>
                 <p className="text-[13.5px] font-normal text-gray-900">{selectedCustomer?.mc ?? "N/A"}</p>
                 </div>
                {selectedCustomer?.source &&
                  <>
                   <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">Source</label>
                     <p className="text-[13.5px] font-normal text-gray-900">{selectedCustomer?.source + " Page" ?? "N/A"}</p>
                     </div>
                  </>
                }
              <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">UserType</label>
                <p className="text-[13.5px] font-normal text-gray-900">{selectedCustomer?.userType}</p>
 </div>
              </div>

               <div className="lg:border-r-[1px] pr-3 lg:border-r-[#EEEEEE]">
  
                <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                    <img src="/assets/img/contact.png" alt="" className='personIcon' />

                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Contact Details</h2>
                            </div>
               <div className="mb-4 h-[40px]">
                                <label className="text-[11px] text-gray-500 block mb-1">Full Name</label>
                 <p className="text-[13.5px] font-normal text-gray-900">{`${selectedCustomer.first_name
                  } ${selectedCustomer.last_name ? selectedCustomer.last_name : ""
                  }`}</p>
                </div>

               <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Phone Number</label>
                 <p className="text-[13.5px] font-normal text-gray-900">
                  {selectedCustomer.phone_number
                    ? selectedCustomer.phone_number
                    : selectedCustomer?.office_info?.phone_number ?? "N/A"}
                </p>
                </div>

                 <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Email</label>
                 <p className="text-[13.5px] font-normal text-gray-900">{selectedCustomer.email}</p>

                 </div>
               <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  City and State</label>
                 <p className="text-[13.5px] font-normal text-gray-900">
                  {selectedCustomer?.office_info?.address ?? "N/A"}
                </p> </div>
              </div>

               <div className=" pr-3 ">
                <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                    <img src="/assets/img/list-info.png" alt="" className='personIcon' />
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Reports</h2>
                            </div>
                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Users:{" "}
                  
                  <span className="text-[13.5px] font-normal text-gray-900">
                    {selectedCustomer?.userId?.length}
                  </span>
                </label>
                </div>

                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Loads: <span className="text-[13.5px] font-normal text-gray-900">0</span>
                </label>
                </div>
               <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Drivers: <span className="text-[13.5px] font-normal text-gray-900">0</span>
                </label>
                </div>
                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Trucks: <span className="text-[13.5px] font-normal text-gray-900">0</span>
                  </label>
                </div>
                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">
                  Trailers: <span className="text-[13.5px] font-normal text-gray-900">0</span>
                </label>
                </div>
              </div>
            
       </div>
      </div>
    </div>
  );
}
